import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

export interface StackProps extends BoxProps {
  /**
   * Children components.
   */
  children: React.ReactNode;
  /**
   * Spacing between content within the stack.
   */
  spacing?: number;
  /**
   * Direction the content should flow within the stack.
   */
  direction?: 'column' | 'row' | 'column-reverse' | 'row-reverse';
}

/**
 * A component to display content with specific spacing and direction.
 */
export const Stack = (props: StackProps) => {
  const {
    children,
    spacing = 0, // Default spacing in Chakra UI is 4 (16px)
    direction = 'column',
    ...restProps
  } = props;

  return (
    <Box
      display="flex"
      flexDirection={direction}
      alignItems="flex-start" // Adjust alignment based on use case
      {...restProps}
    >
      {React.Children.map(children, (child, index) => {
        
        if (child) {
          const isLastChild = index === React.Children.count(children) - 1;

        // Add margin bottom to all children except the last one
        const childProps = {
          ...(isLastChild ? {} : { marginBottom: spacing }),
        };

        return React.cloneElement(child as React.ReactElement, childProps);

        } else {
          // Handle the case where 'child' is null or undefined (optional)
          return null; // Or render a placeholder or fallback component
        }

      })}
    </Box>
  );
};
